import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer-nav.css';

const Footer_navLinks = (props) => {
  return ( 
    <li className={props.className}>
      <NavLink to={props.to} className="nav__link">
        {props.text}
      </NavLink>
    </li>
  );
}

export default Footer_navLinks;